import { Flex, Heading, ModalCloseButton } from "@chakra-ui/react";
import type { HeaderProps } from "./Header.d";

const Header = ({ text, testId }: HeaderProps) => (
  <Flex pb={6} align="center" justify="space-between" data-testid={testId}>
    <Heading variant="h3" as="h3">
      {text}
    </Heading>
    <ModalCloseButton size="md" />
  </Flex>
);

export default Header;
